import { createUseRecipeHook, RecipeVariants } from '@/theme';
import * as style from './Card.css';

export const useCardStyle = createUseRecipeHook(style.root);
export type CardStyleProps = RecipeVariants<typeof style.root>;
